import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosPublic from "../../api/axiosPublic";

export const signupApi = createAsyncThunk(
  "customers-api/registrations/with-kyc",
  async (signupPayload, { rejectWithValue }) => {
    try {
      const { data } = await axiosPublic.post(
        `customers-api/registrations/with-kyc`,
        signupPayload
      );

      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
